import { useMutation, useQueryClient } from '@tanstack/react-query';
import { setCartransfer } from '../api/cartransferService';
import { toast } from '../utils/toasts';
import { useCircuitBreaker } from './useCircuitBreaker';

/**
 * Hook para actualizar archivos específicos de cartransfers
 */
export function useUpdateCartransferFile() {
  const queryClient = useQueryClient();
  const circuitBreaker = useCircuitBreaker(10, 30000); // 10 llamadas, 30 segundos timeout
  
  return useMutation({
    mutationFn: ({ id, data }) => {
      console.log('useUpdateCartransferFile mutationFn called', { id, data });
      return circuitBreaker.execute(setCartransfer, id, data);
    },
    onSuccess: (data, variables) => {
      // Invalidar queries relacionadas
      queryClient.invalidateQueries({ queryKey: ['cartransfers'] });
      // Comentado para evitar bucle infinito
      // queryClient.invalidateQueries({ queryKey: ['cartransfer', variables.id] });
      return data;
    },
    onError: (error) => {
      toast('error', error?.response?.data?.message || 'Error al actualizar archivo');
    },
  });
} 